import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-blush px-5 py-10" data-id="element-188" data-mp="3fyhnbo0xqj8f">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-189" data-mp="2et0hejprk1c6">
        <p className="text-sm font-medium text-foreground sm:text-base" data-id="element-190" data-mp="29ufjiqxzhtqw">
          <span className="tracking-wider text-primary" aria-label="5 de 5 estrellas" data-id="element-191" data-mp="29scuoa8ki6nr">★★★★★</span> 4.9/5 · Más de
          500 personas ya empezaron a aprender coreano con este método
        </p>
      </div>
    </section>;
}